<template>
    <div class="page-container">
        <MNewUserRegister />
    </div>
</template>
<script>
//引入组件
import MNewUserRegister from '@/components/MNewUserRegister';

export default {
    name: "",
    data: () => ({

    }),
    computed: {

    },
    created(){
    },
    methods: {
    },
    components: {
        MNewUserRegister
    }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/List2/index.vue